import { ValueConcept } from '../types/ValueConcept';
import { TAG } from '../../tag/TAG';

export interface UpdateValueConceptsRequest {
  readonly value_concepts: ReadonlyArray<ValueConcept>;
}

export interface UpdateValueConceptsResponse {
  readonly value_concepts: ReadonlyArray<ValueConcept>;
}

export const UpdateValueConcepts = (fieldConceptKey: string, valueConcepts: ReadonlyArray<ValueConcept>): Promise<UpdateValueConceptsResponse> => {
  return TAG.Put<UpdateValueConceptsRequest, UpdateValueConceptsResponse>(`semantic-model/data-roles/${fieldConceptKey}/value-concepts`, {value_concepts: valueConcepts});
};
